import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="bg-ink text-white min-h-screen flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="w-full max-w-md bg-surface border border-white/10 rounded-2xl p-8 text-center shadow-2xl">
        <XCircle size={56} className="mx-auto text-slate-500" />
        <h1 className="mt-6 font-heading font-bold text-2xl">Checkout canceled</h1>
        <p className="mt-3 text-sm text-slate-400">
          No worries — you have not been charged. Your lifetime license is still waiting whenever you're ready.
        </p>
        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/#pricing" data-testid="cancel-retry-button"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-cyan text-ink font-heading font-bold uppercase tracking-wide text-sm hover:bg-cyan-hover transition-all">
            Try again
          </Link>
          <Link to="/" data-testid="cancel-back-home"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl border border-white/15 text-white font-heading font-bold uppercase tracking-wide text-sm hover:border-cyan/50 hover:text-cyan transition-all">
            <ArrowLeft size={18} /> Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
